import { render } from "./TableDataAnak.vue?vue&type=template&id=489ad95e"
import script from "./TableDataAnak.vue?vue&type=script&lang=js"
export * from "./TableDataAnak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__